import { useState } from 'react';

import { MdKeyboardArrowRight } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';

interface Community {
  id: string;
  name: string;
  address: string;
}

const communities: Community[] = [
  {
    id: '1',
    name: 'Mantra Residence',
    address: '4b Prince Adedeji Adelowo.....',
  },
  {
    id: '2',
    name: 'Palm City Residence',
    address: '4b Prince Adedeji Adelowo.....',
  },
  {
    id: '3',
    name: 'Divine Homes Resident..',
    address: '4b Prince Adedeji Adelowo.....',
  },
];

const SelectCommunity = () => {
  const [selectedCommunity, setSelectedCommunity] = useState<string>('');

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';

  const handleContinue = () => {
    if (!selectedCommunity) return;
    console.log('Selected Community:', selectedCommunity);
    navigate(from, { replace: true });
  };

  return (
    <div className="w-full">
      <div className="space-y-4 sm:space-y-5 lg:space-y-6 w-full">
        {/* Content */}
        <div>
          <h1 className="text-2xl leading-tight font-bold text-pry">
            Select Community
          </h1>
          <p className="mt-4 text-base font-inter leading-relaxed text-[#8692A6]">
            Welcome back, Please choose the estate you would like to access.
          </p>

          <div className="h-px bg-[#E6E7EB] mt-6 mb-6" />

          {/* Community List */}
          <div className="space-y-3">
            {communities.map((community) => {
              const isSelected = selectedCommunity === community.id;

              return (
                <button
                  key={community.id}
                  onClick={() => setSelectedCommunity(community.id)}
                  className={`w-full flex items-center justify-between rounded-2xl px-6 py-3 transition-all duration-100 ease-in-out ${
                    isSelected
                      ? 'border-2 border-secondary/60 bg-white'
                      : 'bg-[#F2F3F6] hover:bg-[#E6E7EB]'
                  }
                  `}
                >
                  <div className="text-left">
                    <h3 className="text-base font-semibold text-[#202124]">
                      {community.name}
                    </h3>

                    <p className="mt-2 text-sm text-[#70757F]">
                      {community.address}
                    </p>
                  </div>

                  <MdKeyboardArrowRight size={24} className="text-[#254EDB]" />
                </button>
              );
            })}
          </div>

          {/* Continue Button */}
          <button
            onClick={handleContinue}
            disabled={!selectedCommunity}
            className="mt-10 py-3.5 w-full rounded-xl bg-[#1565D8] text-white text-base font-medium shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#1565D8]/90 flex items-center justify-center gap-2"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectCommunity;
